import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { UsersControllerModule } from './controllers/UsersController';
import { UsersEditView } from './edit/edit';
import { UsersListView } from './list/list';

export const UsersView = angular
  .module('acme.view.application.users', [
    uiRouter,
    'ui.bootstrap',
    UsersEditView,
    'acme.view.application.users.assign',
    'acme.view.application.users.detail',
    UsersListView,
    'acme.view.application.users.schedule',
    UsersControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.users',
      url: '/users',
      abstract: true,
      views: {
        'subview-main': {
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/users/users.tpl.html',
        },
      },
      data: {
        pageTitle: 'Users',
        permissions: ['USERS_VIEW'],
        roles: ['admin'],
      },
    });
  }).name;
